/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Connections_HintInputs */



/**
* | output |
* | --- |
* | "Each connection has two halves: its knowledge, and its tools. Tick what this project may use. Knowledge becomes readable for the whole project; tools stay li..." |
*
* @param {Project_References_Connections_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_connections_hint = /** @type {((inputs?: Project_References_Connections_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Connections_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jede Verbindung hat zwei Hälften: ihr Wissen und ihre Werkzeuge. Wählen Sie aus, was dieses Projekt nutzen darf. Wissen wird für das ganze Projekt lesbar; Werkzeuge bleiben auf die beschränkt, die ohnehin Zugriff auf die Verbindung haben.")
	return /** @type {LocalizedString} */ ("Each connection has two halves: its knowledge, and its tools. Tick what this project may use. Knowledge becomes readable for the whole project; tools stay limited to whoever already has access to the connection.")
});